import React, { useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  Zoom,
} from '@mui/material';
import { styled } from '@mui/system';

// MUI Icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoIcon from '@mui/icons-material/Info';

const iconMap = {
  success: <CheckCircleIcon sx={{ fontSize: 64, color: '#28a745' }} />,
  error: <ErrorIcon sx={{ fontSize: 64, color: '#dc3545' }} />,
  warning: <WarningAmberIcon sx={{ fontSize: 56, color: '#ff9800' }} />,
  info: <InfoIcon sx={{ fontSize: 56, color: '#ff9800' }} />,
};

const colorMap = {
  success: '#28a745',
  error: '#dc3545',
  warning: '#afb817',
  info: '#17a2b8',
  confirm: '#afb817',
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '25px',
    padding: theme.spacing(2),
    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
    textAlign: 'center',
    minWidth: '475px',
  },
}));

const AlertModal = ({
  type = 'info',
  title,
  message,
  showModal,
  onClose,
  onConfirm,
  onCancel,
  isConfirm = false,
  buttonText = 'OK',
  autoClose,
}) => {
  const icon = iconMap[type] || iconMap.info;
  const color = colorMap[type] || colorMap.info;

  useEffect(() => {
    if (showModal && autoClose) {
      const timer = setTimeout(onClose, autoClose);
      return () => clearTimeout(timer);
    }
  }, [showModal, autoClose, onClose]);

  return (
    <StyledDialog
      open={showModal}
      onClose={onClose}
      TransitionComponent={Zoom}
      keepMounted
    >
      <DialogTitle sx={{ p: 1 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box mb={0.1}>{icon}</Box>
          <Typography variant="h6" gutterBottom sx={{ mb: 0.1, fontSize:'14px !important' }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, px: 1 }}>
        <Typography variant="body1" sx={{ mt: 0.5, fontSize:'13px !important' }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        {isConfirm ? (
          <>
            <Button onClick={onCancel || onClose} variant="outlined">
              No
            </Button>
            <Button
              onClick={onConfirm}
              
              sx={{
                backgroundColor: type === 'warning' ? '#e65100 !important' : color,
                color: '#fff',
                '&:hover': {
                  backgroundColor: type === 'warning' ? '#d84315 !important' : `${color}cc`,
                },
              }}
            >
              Yes
            </Button>
          </>
        ) : (
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: '#de6b14 !important',
              color: 'white !important',
              padding: '10px 20px',
              border: '1px solid #de6b14 !important',
              borderRadius: '5px',
              fontSize: '14px',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              '&:hover': {
                backgroundColor: '#c85c10 !important',
              },
            }}
          >
            {buttonText}
          </Button>
        )}
      </DialogActions>
    </StyledDialog>
  );
};

export default AlertModal;
